'use strict';

require('babel-register');

module.exports = {
  components: require('./components').components,
  styles: require('./styles').styles,
  utils: require('./utils').utils
};


//////////////////
// WEBPACK FOOTER
// ../~/bastetjs/lib/index.js
// module id = 21
// module chunks = 0